import { Framework } from '@/framework';
import { RULER_BAR_EVENTS, RULER_BAR_SIZE } from './constants';
import { setRulerBarVisibility } from './operations/set-ruler-bar-visibility';
import { getRulerState } from './states/ruler-state';

/** 标尺插件的实例级操作入口。 */
export class RulerBar extends Framework {
    /** 显示标尺 */
    showRulerBar() {
        setRulerBarVisibility(this.identity, true);
    }

    /** 隐藏标尺 */
    hideRulerBar() {
        setRulerBarVisibility(this.identity, false);
    }

    getShowRulerBar() {
        return getRulerState(this.identity).showRulerBar;
    }

    /** 获取标尺固定宽高，不受当前显示状态和 React 渲染时序影响。 */
    getRulerBarSize() {
        return RULER_BAR_SIZE;
    }

    /** 获取当前标尺状态占用的宽高；隐藏时返回 0。 */
    getVisibleRulerBarSize() {
        return getRulerState(this.identity).showRulerBar ? RULER_BAR_SIZE : 0;
    }

    /** 监听标尺显示状态变化；返回函数用于解绑。 */
    onShowRulerBarChanged(callback: (show: boolean) => void) {
        const handler = this.framework.service.events.on(RULER_BAR_EVENTS.ON_SHOW_CHANGED, callback);
        return () => this.framework.service.events.off(handler);
    }

    /** 通知当前编辑器实例标尺显示状态已变化。 */
    emitShowRulerBarChanged(show: boolean) {
        this.framework.service.events.emit(RULER_BAR_EVENTS.ON_SHOW_CHANGED, show);
    }

    destroy() {}
}
